/* eslint-disable react/prop-types */
import classes from "./only-backend.module.scss";

import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import Grid from "@/components-library/layout/grid";
import TextArea from "@/components-library/widgets/text-area";
import TextField from "@/components-library/widgets/text-field";
function OnlyBackend({
  onInternalNotesChange,
  onFollowedCompaniesChange,
  onReportingPriceChange,
  onQuestionPriceChange,
  onYearChange,
  announcement,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classes.infoContainer}
    >
      <Label
        tag="h6"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.subTitle}
      >
        Solo backend
      </Label>
      <Grid columns="1fr 1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea)}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Anno uscita bando
          </Label>
          <TextField
            type="number"
            name="numeric"
            isEnabled={true}
            onChange={onYearChange}
            value={announcement?.year}
            className={classes.textField}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea)}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Prezzo richiesto in domanda
          </Label>
          <TextArea
            name="Title"
            rows={3}
            onChange={onQuestionPriceChange}
            defaultValue={announcement?.questionPrice}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea)}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Prezzo richiesto in rendicontazione
          </Label>
          <TextArea
            name="Title"
            rows={3}
            onChange={onReportingPriceChange}
            defaultValue={announcement?.reportingPrice}
          />
        </Flex>
      </Grid>
      <Grid columns="1fr 1fr">
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea)}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Aziende seguite
          </Label>
          <TextArea
            name="Title"
            rows={3}
            onChange={onFollowedCompaniesChange}
            defaultValue={announcement?.followedCompanies}
          />
        </Flex>
        <Flex
          align="flex-start"
          direction="column"
          justify="flex-start"
          className={classNames(classes.textArea)}
        >
          <Label tag="p" size="md" align="start" color="secondary">
            Note interne
          </Label>
          <TextArea
            name="Title"
            rows={3}
            onChange={onInternalNotesChange}
            defaultValue={announcement?.internalNotes}
          />
        </Flex>
      </Grid>
    </Flex>
  );
}

export default OnlyBackend;
